/* ============================================================
   555 SHOP — Comparateur avant/après (vierge / floqué)
   - Avance tout seul au scroll (vierge -> floqué).
   - Reste glissable à la main (souris / tactile / clavier) ;
     dès que l'utilisateur agit, le manuel prend le dessus.
   - Sans JS / reduced-motion / éditeur : comparaison statique.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode');
  var POS_LOW = 16, POS_HIGH = 84;

  function initCompare(frame) {
    if (!frame || frame.dataset.compareReady === '1') return;
    frame.dataset.compareReady = '1';

    var handle = frame.querySelector('[data-compare-handle]');
    var MIN = 3, MAX = 97;
    var dragging = false;
    var userControlled = false;

    function setPos(p) {
      p = Math.max(MIN, Math.min(MAX, p));
      frame.style.setProperty('--pos', p + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
    }
    function posFromX(clientX) {
      var r = frame.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    }
    function takeOver() { userControlled = true; }

    /* ---- Manual drag ---- */
    frame.addEventListener('pointerdown', function (e) {
      dragging = true; takeOver();
      frame.classList.add('is-dragging');
      setPos(posFromX(e.clientX));
      if (frame.setPointerCapture && e.pointerId != null) { try { frame.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    frame.addEventListener('pointermove', function (e) { if (dragging) setPos(posFromX(e.clientX)); });
    function stop() { dragging = false; frame.classList.remove('is-dragging'); }
    frame.addEventListener('pointerup', stop);
    frame.addEventListener('pointercancel', stop);

    if (handle) {
      handle.addEventListener('pointerdown', function (e) { e.stopPropagation(); dragging = true; takeOver(); frame.classList.add('is-dragging'); });
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(frame.style.getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft')  { takeOver(); setPos(cur - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { takeOver(); setPos(cur + 4); e.preventDefault(); }
        if (e.key === 'Home')       { takeOver(); setPos(MIN); e.preventDefault(); }
        if (e.key === 'End')        { takeOver(); setPos(MAX); e.preventDefault(); }
      });
    }

    /* ---- Scroll-driven (until the user takes over) ---- */
    if (reduce || design) return;

    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      window.ScrollTrigger.create({
        trigger: frame,
        start: 'top 80%',
        end: 'bottom 55%',
        scrub: true,
        onUpdate: function (self) {
          /* Sens inversé : curseur démarre à DROITE (POS_HIGH = vierge dominante)
             et balaye vers la GAUCHE (POS_LOW = floqué dominant) au scroll. */
          if (!userControlled) setPos(POS_HIGH - self.progress * (POS_HIGH - POS_LOW));
        }
      });
    } else {
      var ticking = false;
      function onScroll() {
        if (ticking || userControlled) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (userControlled) return;
          var r = frame.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var prog = (vh * 0.8 - r.top) / (vh * 0.8 - vh * 0.55 + r.height);
          prog = Math.max(0, Math.min(1, prog));
          /* Sens inversé : vierge -> floqué */
          setPos(POS_HIGH - prog * (POS_HIGH - POS_LOW));
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAll(root) { (root || document).querySelectorAll('[data-compare]').forEach(initCompare); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
